'use client';

import AuthGuard from '@/src/components/AuthGuard';
import { ApiProvider } from '@/src/providers/Api';
import { TenantMeProvider } from '@/src/providers/Me';
import type { ReactNode } from 'react';

import { SessionProvider } from '@/src/providers/Session';

export default function TenantLayout({ children }: { children: ReactNode }) {
  return (
    <ApiProvider>
      <SessionProvider>
        <TenantMeProvider>
          <AuthGuard layout="tenant">{children}</AuthGuard>
        </TenantMeProvider>
      </SessionProvider>
    </ApiProvider>
  );
}
